module.exports = __webpack_public_path__ + "static/img/get_chocolate.d503e78f.png";